import './PaginaVendas.css';

const PLANS = [
    {
        id: 'profissional',
        name: 'Plano Profissional',
        icon: '💎',
        popular: true,
        features: [
            'Até 20 Barbeiros',
            'Agenda Online Ilimitada',
            'Relatórios Completos',
            'Controle Financeiro Total',
            'Sistema de Fidelidade',
            'Suporte WhatsApp VIP',
            '7 DIAS DE TESTE GRÁTIS'
        ]
    }
];

const PaginaVendas = ({ onLoginClick, user, onNavigate, onStartRegistration }) => {
    return (
        <div className="sales-page">
            <nav className="sales-nav">
                <div className="nav-logo">StartWebb</div>
                <div className="nav-links">
                    <a href="#home">Início</a>
                    <a href="#planos">Planos</a>
                    <button className="nav-login-btn" onClick={() => onLoginClick('login')}>ENTRAR</button>
                </div>
            </nav>

            <div className="sales-content">
                <section id="home" className="hero-section">
                    <div className="hero-badge">PLANO PROFISSIONAL DISPONÍVEL</div>
                    <h1 className="hero-title">A Gestão da Sua Barbearia em um Novo Nível.</h1>
                    <p className="hero-subtitle">Módulos de agendamento online, controle financeiro completo e fidelização de clientes. Tudo em uma única plataforma premium.</p>
                    <div className="hero-actions">
                        <a href="#planos" className="primary-btn">ASSINAR AGORA — 7 DIAS GRÁTIS</a>
                        <button className="secondary-btn" onClick={() => onLoginClick('login')}>JÁ SOU CLIENTE</button>
                    </div>
                </section>

                <section id="planos" className="plans-container">
                    <div className="section-header">
                        <h2 className="section-title">O Único Plano que Você Precisa</h2>
                        <p className="section-subtitle">Tudo o que sua barbearia precisa por um preço justo e transparente.</p>
                    </div>

                    <div className="sales-plans-grid">
                        {PLANS.map((plan) => (
                            <div key={plan.id} className="sales-plan-card popular">
                                <div className="popular-badge">PLANO COMPLETO</div>
                                <div className="plan-icon">{plan.icon}</div>
                                <h3>{plan.name}</h3>
                                <div className="plan-price" style={{ fontSize: '1.4rem', color: '#DAA520', marginBottom: '10px' }}>7 DIAS GRÁTIS</div>
                                <div className="plan-limit-info">Até 20 Barbeiros</div>
                                <ul>
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx} style={feature.includes('GRÁTIS') ? { color: '#4dff88', fontWeight: 900 } : {}}>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                                <button
                                    className="plan-cta-btn"
                                    onClick={() => onStartRegistration(plan.id)}
                                >
                                    TESTAR 7 DIAS GRÁTIS
                                </button>
                                <p className="plan-footer-note">Cancele quando quiser dentro dos 7 dias.</p>
                            </div>
                        ))}
                    </div>
                </section>
            </div>

            <footer className="sales-footer">
                <div className="footer-content">
                    <div className="footer-brand">StartWebb</div>
                    <div className="footer-info">
                        <p>&copy; 2024 StartWebb - Excelência em Gestão para Barbeiros</p>
                        <a
                            href="https://wa.me/5534997354131?text=Olá! Gostaria de tirar algumas dúvidas sobre o StartWebb."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-support-link"
                        >
                            Falar com Suporte: (34) 99735-4131
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PaginaVendas;
